import React from 'react';
import { constantStyles } from '../constants/constantStyles';
import { useMediaQuery } from 'react-responsive';

const Logo = () => {

    const isMobile = useMediaQuery({ maxWidth: constantStyles.mobileWidth });

    return (
        <div style={{ ...styles.logoGeneral, ...styles.longLogo }} onClick={() => window.location.href = '/'}>
            {isMobile ? <div style={styles.mobileLogoHolder}>
                <img style={styles.mobileLogo} src='/images/small_logo.png' alt="The Sidewalk Brand Logo" />
            </div> :
                <>
                    <div style={{ ...styles.align, ...styles.the }}>The</div>
                    <div style={{ ...styles.align, ...styles.sidewalk }}>Sidewalk</div>
                    <div style={{ ...styles.align, ...styles.co }}>Co.</div>
                </>}
        </div>
    );
}

export default Logo;

const styles = {
    longLogo: { display: 'flex', flexShrink: 1, },
    logoGeneral: {
        textTransform: 'uppercase',
        fontFamily: constantStyles.mainFontFamily,
        color: constantStyles.mainDarkGreen,
        cursor: 'pointer',
    },
    align: {
        display: 'flex',
        flexShrink: 1,
        overflow: 'hidden',
    },
    the: {
        fontSize: '16px',
    },
    sidewalk: {
        fontSize: '30px',
    },
    co: {
        fontSize: '14px',
        fontWeight: 'lighter',
        justifyContent: 'flex-end', // remove to go back to old logo
        flexDirection: 'column', // remove to go back to old logo
    },
    mobileLogo: {
        height: '48px',
    },
    mobileLogoHolder: {
        display: 'flex',
        flexShrink: 1,
        overflow: 'hidden',
    },
};